import { ReportData } from './reportData';

export interface HeadCell {
  id: keyof ReportData;
  label: string;
}

export const eventHeaders: HeadCell[] = [
  {
    id: 'eventId',
    label: 'Event Id',
  },
  {
    id: 'lid',
    label: 'LID',
  },
  {
    id: 'subProgram',
    label: 'Subprogram',
  },
  {
    id: 'account',
    label: 'Account',
  },
  {
    id: 'area',
    label: 'Area',
  },
  {
    id: 'lastPictureDay',
    label: 'Last Event Date',
  },
];

export const pictureDayHeaders: HeadCell[] = [
  {
    id: 'eventId',
    label: 'Event ID',
  },
  {
    id: 'lid',
    label: 'LID',
  },
  {
    id: 'subProgram',
    label: 'Subprogram',
  },
  {
    id: 'account',
    label: 'Account',
  },
  {
    id: 'area',
    label: 'Area',
  },
  {
    id: 'startTime',
    label: 'Start Time',
  },
  {
    id: 'timeZone',
    label: 'Time Zone',
  },
  {
    id: 'firstPictureDay',
    label: 'Picture Date',
  },
  {
    id: 'status',
    label: 'Connection Status',
  },
];

export const quarantineEventHeaders: HeadCell[] = [
  {
    id: 'eventId',
    label: 'Event Id',
  },
  {
    id: 'apoId',
    label: 'APO ID',
  },
  {
    id: 'account',
    label: 'Account',
  },
  {
    id: 'area',
    label: 'Area',
  },
  {
    id: 'imageCount',
    label: '# of images'
  },
  {
    id: 'pibCount',
    label: '# of PIBs'
  },
  {
    id: 'uploadDate',
    label: 'Upload Date',
  },
  {
    id: 'photographerId',
    label: 'Photographer ID',
  },
  {
    id: 'cameraSerialNumber',
    label: 'Camera Serial Number',
  },
  {
    id: 'eventScheduledDate',
    label: 'Event Scheduled Date',
  },
  {
    id: 'numberOfOrders',
    label: 'Number of Orders',
  },
  {
    id: 'status',
    label: 'Status',
  },
];

export const emCompleteEventDetailsHeaders: HeadCell[] = [
  {
    id: 'eventId',
    label: 'Event ID',
  },
  {
    id: 'lid',
    label: 'LID',
  },
  {
    id: 'subProgram',
    label: 'Subprogram',
  },
  {
    id: 'account',
    label: 'Account',
  },
  {
    id: 'area',
    label: 'Area',
  },
  {
    id: 'photographyEndTime',
    label: 'Photography End Time'
  },
  {
      id: 'timeZone',
      label: 'Time Zone',
  },
  {
    id: 'emCompleteDate',
    label: 'EM Complete Time'
  },
  {
    id: 'status',
    label: 'EM Completion Status',
  },
];

export const emCompleteEventDetailsHeadersMobile: HeadCell[] = [
  {
    id: 'eventId',
    label: 'Event ID',
  },
  {
    id: 'photographyEndTime',
    label: 'Photography End Time'
  },
  {
    id: 'status',
    label: 'Status',
  },
];

export const eventHeadersMobile: HeadCell[] = [
  {
    id: 'eventId',
    label: 'Event Id',
  },
  {
    id: 'area',
    label: 'Area',
  },
  {
    id: 'lastPictureDay',
    label: 'Last Event Date',
  },
];

export const pictureDayHeadersMobile: HeadCell[] = [
  {
    id: 'eventId',
    label: 'Event ID',
  },
  {
    id: 'area',
    label: 'Area',
  },
  {
    id: 'firstPictureDay',
    label: 'Picture Date',
  },
  {
    id: 'status',
    label: 'Status',
  },
];

export const quarantineEventHeadersMobile: HeadCell[] = [
  {
    id: 'eventId',
    label: 'Event Id',
  },
  {
    id: 'area',
    label: 'Area',
  },
  {
    id: 'imageCount',
    label: 'Images'
  },
  {
    id: 'pibCount',
    label: 'PIBs'
  },
  {
    id: 'uploadDate',
    label: 'Upload Date',
  },
  {
    id: 'photographerId',
    label: 'Photographer ID',
  },
  {
    id: 'cameraSerialNumber',
    label: 'Camera Serial #',
  },
  {
    id: 'eventScheduledDate',
    label: 'Scheduled Date',
  },
  {
    id: 'numberOfOrders',
    label: '# Orders',
  },
  {
    id: 'status',
    label: 'Status',
  },
];